var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62988 13.0609L13.208 11L9.62988 8.93921V13.0609Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.9258 0 0 4.9258 0 11C0 17.0742 4.9258 22 11 22C17.0742 22 22 17.0742 22 11C22 4.9258 17.0742 0 11 0ZM17.8733 11.0112C17.8733 11.0112 17.8733 13.2421 17.5903 14.3178C17.4317 14.9066 16.9675 15.3709 16.3786 15.5293C15.3029 15.8125 11 15.8125 11 15.8125C11 15.8125 6.70833 15.8125 5.62135 15.5181C5.03255 15.3596 4.56828 14.8952 4.40967 14.3064C4.12651 13.2421 4.12651 11 4.12651 11C4.12651 11 4.12651 8.76932 4.40967 7.69359C4.56812 7.10478 5.04379 6.6291 5.62135 6.47066C6.69708 6.1875 11 6.1875 11 6.1875C11 6.1875 15.3029 6.1875 16.3786 6.4819C16.9675 6.64035 17.4317 7.10478 17.5903 7.69359C17.8847 8.76932 17.8733 11.0112 17.8733 11.0112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.70ef45de.svg";
export { ForwardRef as ReactComponent };